import * as React from "react";
import EditorialBase from "components/flexComponents/Content/factory/EditorialBase";
import { UitkCardAloha } from "uitk-react-cards";
import { UitkText, UitkHeading, UitkSubheading } from "uitk-react-text";
import { UitkSpacing } from "uitk-react-spacing";
import { UitkLayoutGrid, UitkLayoutGridItem } from "uitk-react-layout-grid";
import { ContentFlexComponent, ContentProps } from "components/flexComponents/Content/typings";
import { decorateEditorialHtml } from "components/flexComponents/Content/ContentUtilities";
import { UitkPrimaryButton } from "uitk-react-button";
import MediaDisplay from "../items/MediaDisplay";

export class HalfMediaEditorial extends EditorialBase {
  public constructor(editorial: ContentFlexComponent) {
    super(editorial);
  }

  /**
   * An Editorial consists of HTML strings that we parse through with the best of
   * our abilities and display as is on the page. Mainly, we do not control the
   * content of an Editorial, we simply put them in the page.
   */
  public generate(props: ContentProps) {
    const { context } = props;
    const { cardLinkLabel, cardLinkUrl, title: moduleTitle, subtitle: moduleSubtitle } = this.editorial;
    const { id, text, title, media, subtitle } = this.editorial.items[0];

    if (!media || media.length === 0) {
      return null;
    }

    return (
      <UitkSpacing padding={{ block: "three" }}>
        <div
          id={this.flexComponent.id}
          data-fm={this.flexComponent.fmId}
          data-fm-title-id={this.flexComponent.fmTitleId}
          className="HalfMediaEditorial"
        >
          <UitkCardAloha border={true}>
            <div>
              <UitkLayoutGrid columns={{ small: 1, medium: 2 }} justifyContent="space-between">
                <UitkLayoutGridItem>
                  <div>
                    <MediaDisplay id={id} media={media} title={title} context={context} />
                  </div>
                </UitkLayoutGridItem>
                <UitkLayoutGridItem>
                  <div>
                    <UitkSpacing padding={{ block: "three", inline: "four" }}>
                      <div>
                        {moduleTitle && (
                          <UitkSpacing margin={{ blockend: "two" }}>
                            <div>
                              <UitkHeading level={2} size={500}>
                                {moduleTitle}
                              </UitkHeading>
                              {moduleSubtitle && <UitkSubheading>{moduleSubtitle}</UitkSubheading>}
                            </div>
                          </UitkSpacing>
                        )}
                        {title && (
                          <div>
                            <UitkHeading level={moduleTitle ? 3 : 2} size={500}>
                              {title}
                            </UitkHeading>
                            {subtitle && <UitkSubheading>{subtitle}</UitkSubheading>}
                          </div>
                        )}
                        <UitkSpacing margin={{ blockstart: "two" }}>
                          <UitkText size={300}>
                            <div dangerouslySetInnerHTML={decorateEditorialHtml(text)} />
                          </UitkText>
                        </UitkSpacing>
                        {cardLinkUrl && cardLinkLabel && (
                          <UitkSpacing margin={{ blockstart: "four" }}>
                            <UitkPrimaryButton text={cardLinkLabel} href={cardLinkUrl} />
                          </UitkSpacing>
                        )}
                      </div>
                    </UitkSpacing>
                  </div>
                </UitkLayoutGridItem>
              </UitkLayoutGrid>
            </div>
          </UitkCardAloha>
        </div>
      </UitkSpacing>
    );
  }
}

export default HalfMediaEditorial;
